<!-- <app-edite-user-details></app-edite-user-details> -->
<!-- start header  -->
<header>
    <app-head (newItemEvent)="addItem($event)" [titleModule]="'checkOut'"></app-head>
</header>
<!-- end header  -->

<div class="row m-0">

    <!-- start sidebar  -->
    <app-sidebar class="col-lg-2" [showSide]="showSide" [titlepage]="'checkOut'"></app-sidebar>
    <!-- end sidebar  -->

    <!-- start content page  -->
    <main class="p-4 col-lg-10 ">
        <div class="d-md-flex justify-content-between" style="margin-top: 6px; margin-bottom: 24px;">
            <div class="d-flex" style="align-items: center;">
                <p class="fw-bold me-2" style="color: #6c6a6a;margin-bottom: 0px;"><a style="color: #6c6a6a;" class="removeUnderLine"
                        routerLink="/inquiries">Inquiries </a></p>

                <p class="fw-bold me-2" style="margin-bottom: 0px;color: #605D62;">></p>
                <p class="fw-bold" style="color: #6c6a6a;margin-bottom: 0px;">Ready Checkout </p>
            </div>
            <div class="d-flex justify-content-lg-between ">
                <div class="d-flex justify-content-between ">

                </div>
                <app-dropdown [list]="listDropDown" style="margin-top: 2px;" (selected)="selectedfromDropDown($event)"></app-dropdown>

            </div>
        </div>


        <p-toast></p-toast>
        <!------------------------------------------------------>
        <!-- <div class="card">
            <div class="row d-block d-md-flex justify-content-between my-2 p-3">
           
                <div class="col-md-4">
                    <div class="d-flex align-items-center" style="font-size: 15px;">
                        <label for="" style="color: #313331;font-weight: 500;font-size: 16px;">CheckOut</label>
                        <img src="assets/images/line.svg" class="mx-3">
                        <select class="form-select" (change)="clickIquires($event)">
                            <option *ngFor="let data of InquireFillterLists; let index=index;" [value]="data.id"
                                [selected]="InquireFillterSelected[index]">{{ data.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-5 col-8">
                    <div class="input">
                        <input type="text" class="form-control py-2" placeholder=" Search by Inquires" (keyup)="searchAction($event)"
                            [(ngModel)]="searchText" />
                        <img src="../../../assets/images/search.svg" alt="">
                    </div>
                </div>


            </div>
 

            <p-table class="table-shopping" [selectionPageOnly]="true" [tableStyle]="{'min-width': '50rem' ,'min-': '50rem'}"
                [value]="checkOut.length !== 0 ? checkOut : checKoutInstead">
                <ng-template pTemplate="header" class="text-center">
                    <tr *ngIf="headerData">
                        <ng-container>


                            <th class="td-name">
                                booking ID

                            </th>

                            <th class="td-name">
                                User name

                            </th>

                            <th class="td-name">
                                Requested apartment

                            </th>
                            <th class="td-name">
                                deposit

                            </th>
                            <th class="td-name">
                                start date

                            </th>
                            <th class="td-name">
                                end date

                            </th>
                            <th class="td-name">
                                Status

                            </th>

                            <th class="td-name">
                            </th>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-check>

                    <tr (click)="hidecard()" style="cursor: pointer;">
                        <td  [routerLink]="['/checkout-inquire/checkout/',check.req_ID,check.userID]">{{ check.req_Code }}</td>

                        <td  [routerLink]="['/checkout-inquire/checkout/',check.req_ID,check.userID]">
                            <img *ngIf="check.user_Photo" [src]="check?.user_Photo"
                                style="height: 50px;width: 50px;border-radius: 50%;margin-right: 9px; cursor: pointer;">
                            <img *ngIf="!check.user_Photo" src="../../../assets/images/Frame 1261154899.svg"
                                style="height: 50px;width: 50px;border-radius: 50%;margin-right: 9px;cursor: pointer;">
                            {{ check?.user_Name }}

                        </td>
                        <td  [routerLink]="['/checkout-inquire/checkout/',check.req_ID,check.userID]">
                            {{ check?.rented_Apt }}
                        </td>
                        <td  [routerLink]="['/checkout-inquire/checkout/',check.req_ID,check.userID]">
                            {{ check?.rent_Deposit }}
                        </td>

                        <td  [routerLink]="['/checkout-inquire/checkout/',check.req_ID,check.userID]">
                            {{ check?.start_Date }}
                        </td>
                        <td  [routerLink]="['/checkout-inquire/checkout/',check.req_ID,check.userID]">
                            {{ check?.end_Date }}
                        </td>

                        <td  [routerLink]="['/checkout-inquire/checkout/',check.req_ID,check.userID]">
                            <span class="spanready" *ngIf="check.status=='Ready'">
                                <img src="../../../assets/images/ready.svg">
                                {{ check.status }}</span>
                            <span class="spanready" style="background-color: #ECFDF3;" *ngIf="check.status=='Completed'">
                                <img src="../../../assets/images/comp.svg">
                                {{ check.status }}</span>
                            <span class="spanready" style="background-color: #FFF4ED;" *ngIf="check.status=='End Soon'">
                                <img src="../../../assets/images/end.svg">
                                {{ check.status }}</span>
                                <span class="spanready" style="background-color: #fff700;" *ngIf="check.status?.includes('End in')">
                                  <img src="../../../assets/images/end.svg">
                                  {{ check.status }}</span>
                                  <span class="spanready" style="background-color: #77004a; color:white;" *ngIf="check.status?.includes('Waiting')">
                                    <img src="../../../assets/images/comp.svg">
                                    {{ check.status }}</span>

                        </td>


                        <td class="cursor position-relative" style="text-align: center;">
                            <button class="border-0 outlin-0 bg-transparent" (click)="detailperson($event,check.req_ID)">
                                <img src="assets/images/edit.svg">
                            </button>
                            <div *ngIf="showEdit[check.req_ID] " style="width: 191px;z-index: 999;right: 98px;"
                                class="position-absolute z-3 rounded-3 bg-white border edit-button">

                                <button class="d-block border-0 outlin-0 bg-transparent button w-100 text-start py-2"
                                [routerLink]="['/checkout-inquire/checkout/',check.req_ID,check.userID]"
                                    > View Details </button>
                                    <button class="d-block border-0 outlin-0 bg-transparent button w-100 text-start py-2"
                                    (click)="goBookingDetails(check.req_ID ,check.userID)"> View Booking Details </button>
                                <button class="d-block border-0 outlin-0 bg-transparent button w-100 text-start py-2"
                                    (click)="GetBankDetails(check.req_ID)"> Show Bank Details </button>
                                <button class="d-block border-0 outlin-0 bg-transparent button w-100 text-start py-2"
                                    (click)="GetRefundDetails(check.req_ID)"> Refund Process </button>
                                <button class="d-block border-0 outlin-0 bg-transparent button w-100 text-start py-2"
                                    [disabled]="check.status!=''" (click)="InsertCheckOut(check.req_ID,check.userID)"> Send Checkout Sheet </button>


                            </div>

                        </td>

                    </tr>

                </ng-template>


                <ng-template pTemplate="emptymessage">
                    <div class="container text-center mt-4">
                        <p class="mb-0">No data found.</p>
                    </div>
                </ng-template>

            </p-table>
            <p-paginator *ngIf="checkOut.length > 0" (onPageChange)="tiggerPageChange($event)" [rows]="rows"
              [totalRecords]="totalRecords" [first]="first"></p-paginator>

     
        </div> -->
        <!-------------------------updates----------------------------->

        

      <!-----------------------------------------------------------update----------------------------------------------------------------------------->
      <div>
        <div class="p-card p-3" style="border-radius: 16px;" >
          <div class="flex justify-content-between align-items-center mb-4" style="display: flex;">
            <!-- <h2>Subscription Alerts</h2> -->
             <!-- <div class="card-header">Users <span> {{numberTenants}} Users</span></div> -->
             <div class="d-flex mx-2 mt-4">
              <p class="me-2 fs-5 fw-bold ml-8">CheckOut</p>
              <p class="mb-3 bg-gray rounded-5 blue px-2 d-flex align-items-center">
                  {{totalRecords}} checkOut
              </p>
          </div>
            <div class="p-inputgroup w-50" style=" position: relative;">
              <!-- <span class="p-inputgroup-addon">
                <i class="pi pi-search"></i>
              </span> -->
              <input type="text"  class="search-input" pInputText placeholder="      Search any Keywords" [(ngModel)]="globalFilter" (input)="dt2.filterGlobal(globalFilter, 'contains')" />
              <i class="pi pi-search search-icon"></i>
              <!-- <button pButton icon="pi pi-filter" class="p-button-outlined"></button> -->
               <!-- <img src="filterplan.svg" (click)="openFilterDialog()"   style="margin-left: 24px; cursor: pointer;"/> -->
            </div>
          </div>
        <!--[paginator]="true"  [rowsPerPageOptions]="[10, 25, 50]"  [rows]="5"-->
        <p-table
        #dt2
        [value]="checkOut"
        dataKey="req_ID"


        *ngIf="tableReady"
        [paginator]="true" 
        [rows]="10"

       
        [first]="checkOut.length > 0 ? currentPage : 0"
        (onPage)="onPageChange($event)"
           
        [rowsPerPageOptions]="[10, 20, 50]"
       
        
        
        
        [globalFilterFields]="['req_Code','user_Name', 'rented_Apt', 'rent_Deposit','start_Date','end_Date','status' ]"
        [tableStyle]="{ 'min-width': '75rem' }"

        [customSort]="true"
        (sortFunction)="customSort($event)"
    >
        <ng-template pTemplate="caption">
            <!-- <div class="flex">
                <p-iconField iconPosition="left" class="ml-auto">
                    <p-inputIcon>
                        <i class="pi pi-search"></i>
                    </p-inputIcon>
                    <input 
                        pInputText 
                        type="text" 
                        (input)="dt2.filterGlobal(globalFilter, 'contains')"
                        placeholder="Search keyword" />
                </p-iconField>
            </div> -->
        </ng-template>
        <ng-template pTemplate="header">
            <tr class="headOne">
                <th style="width:22%">booking ID</th>
                <th style="width:22%">User name</th>
                <th style="width:22%">Requested Appartment</th>
                <th style="width:22%">deposit</th>
                <th style="width:22%"  pSortableColumn="start_Date">start date<p-sortIcon field="start_Date"></p-sortIcon></th>
                <th style="width:22%"  pSortableColumn="end_Date"> end date<p-sortIcon field="end_Date"></p-sortIcon></th> 
           

                <th style="width:22%">Status</th>
                
                <th style="width:6%">Action</th>

            </tr>
            <tr>
                <th style="width:22%">
                    <p-columnFilter 
                        type="text" 
                        field="req_Code" 
                        placeholder="Search by Code" 
                        ariaLabel="Filter Code" />
                </th>
                <th>
                    <p-columnFilter 
                        type="text" 
                        field="user_Name" 
                        placeholder="Search by Name" 
                        ariaLabel="Filter Name" />
                </th>
                <th>
                  <p-columnFilter 
                  type="text" 
                  field="rented_Apt" 
                  placeholder="Search by aptName" 
                  ariaLabel="Filter apt_Name" />
                </th>
               
                <th>
                  <p-columnFilter 
                  type="text" 
                  field="rent_Deposit" 
                  placeholder="Search by rent_Deposit" 
                  ariaLabel="Filter rent_Deposit" />
                </th>
                <th>
                  <p-columnFilter 
                  type="text" 
                  field="start_Date" 
                  placeholder="Search by start_Date" 
                  ariaLabel="Filter start_Date" />
                </th>

                <th>
                  <p-columnFilter 
                  type="text" 
                  field="end_Date" 
                  placeholder="Search by end_Date" 
                  ariaLabel="Filter end_Date" />
                </th>
                
                  <th>
                    <p-columnFilter field="status" matchMode="contains" [showMenu]="false">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-dropdown 
                          [ngModel]="value" 
                          [options]="statuses"
                          optionLabel="label" 
                          optionValue="value"
                          (onChange)="filter($event.value)"  
                          placeholder="Select One" 
                          [showClear]="true">
                          <ng-template let-option pTemplate="item">
                            <p-tag 
                              [value]="option.label" 
                              [severity]="getSeverity(option.label)">
                            </p-tag>
                          </ng-template>
                        </p-dropdown>
                      </ng-template>
                    </p-columnFilter>
                  </th>

                 
                  
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-check>
          <tr style="cursor: pointer;" (click)="hidecard()">

            <td  [routerLink]="['/checkout-inquire/checkout/',check.req_ID,check.userID]">{{ check.req_Code }}</td>

            <td  [routerLink]="['/checkout-inquire/checkout/',check.req_ID,check.userID]">
                <img *ngIf="check.user_Photo" [src]="check?.user_Photo"
                    style="height: 50px;width: 50px;border-radius: 50%;margin-right: 9px; cursor: pointer;">
                <img *ngIf="!check.user_Photo" src="../../../assets/images/Frame 1261154899.svg"
                    style="height: 50px;width: 50px;border-radius: 50%;margin-right: 9px;cursor: pointer;">
                {{ check?.user_Name }}

            </td>
            <td  [routerLink]="['/checkout-inquire/checkout/',check.req_ID,check.userID]">
                {{ check?.rented_Apt }}
            </td>
            <td  [routerLink]="['/checkout-inquire/checkout/',check.req_ID,check.userID]">
                {{ check?.rent_Deposit }}
            </td>

            <td  [routerLink]="['/checkout-inquire/checkout/',check.req_ID,check.userID]">
                {{ check?.start_Date }}
            </td>
            <td  [routerLink]="['/checkout-inquire/checkout/',check.req_ID,check.userID]">
                {{ check?.end_Date }}
            </td>

            <td  [routerLink]="['/checkout-inquire/checkout/',check.req_ID,check.userID]">
                <span class="spanready" *ngIf="check.status=='Ready'">
                    <img src="../../../assets/images/ready.svg">
                    {{ check.status }}</span>
                <span class="spanready" style="background-color: #ECFDF3;" *ngIf="check.status=='Completed'">
                    <img src="../../../assets/images/comp.svg">
                    {{ check.status }}</span>
                <span class="spanready" style="background-color: #FFF4ED;" *ngIf="check.status=='End Soon'">
                    <img src="../../../assets/images/end.svg">
                    {{ check.status }}</span>
                    <span class="spanready" style="background-color: #fff700;" *ngIf="check.status?.includes('End in')">
                      <img src="../../../assets/images/end.svg">
                      {{ check.status }}</span>
                      <span class="spanready" style="background-color: #77004a; color:white;" *ngIf="check.status?.includes('Waiting')">
                        <img src="../../../assets/images/comp.svg">
                        {{ check.status }}</span>

            </td>


                <td  >
                


                    <!----------------------------->
                    <div   class="flex justify-content-start align-items-center gab-3" style="display: flex;">
                        <!-- <div><img class="mr-2" style="cursor: pointer;" src="alertUser.svg"/></div> -->
                        <div class=" ">
                          <img
                          [routerLink]="['/checkout-inquire/checkout/',check.req_ID,check.userID]"
                            class="image-default"
                            src="assets/images/viewPay.svg"
                            alt="Default Alert Icon"
                            
                          />
                           
                        </div>
                        
                        <div  >
                          <img class="mr-2" style="cursor: pointer;" src="assets/images/threeDotPay.svg" (click)="op.toggle($event)" />
                        </div>
                        <p-overlayPanel #op>
                          <ul   class="menu-list list-unstyled">
                            <li><a      style="cursor: pointer; Color:#363636; text-decoration: none;"  
                              [routerLink]="['/checkout-inquire/checkout/',check.req_ID,check.userID]"
                              > View Details  </a></li>
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"    
                              (click)="goBookingDetails(check.req_ID ,check.userID)"> View Booking Details</a></li>
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"  (click)="GetBankDetails(check.req_ID)"> Show Bank Details</a></li>
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"  (click)="GetRefundDetails(check.req_ID)"> Refund Process</a></li>

                            <li><a  style="cursor: pointer; Color:#363636; text-decoration: none;"  (click)="InsertCheckOut(check.req_ID,check.userID)"> Send Checkout Sheet</a></li>
                          
                          </ul>
                        
                         
                        </p-overlayPanel>
                      </div>
                
                </td>
 

            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5">No payments found.</td>
            </tr>
        </ng-template>
</p-table>
<!-- 
	<p-paginator *ngIf="Inquires.length > 0" (onPageChange)="tiggerPageChange($event)" [rows]="rows"
							[totalRecords]="totalRecords" [first]="first"></p-paginator> -->

        </div>
        
      </div>
      <!---------------------------------------------------------------------------------------------------------------------------------------->

        <!------------------------------------------------------>

    </main>
    <!-- end content page  -->
</div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display1}" style=" background-color: rgb(23 22 22 / 50%);;">
    <div class="modal-dialog" role="document" style="max-width: 416px;">
        <div class="modal-content" style="margin-top: 150px;">
            <div class="modal-header" style="background-color:#ffffff; border-bottom: none !important;    padding-bottom: 0px;position: relative;">
                <p class="modal-title"
                    style="color: #1C1B1F; font-size: 20px;   font-weight: 600; line-height: 24px; word-wrap: break-word">
                    <span class="form-label gray fw-bold" style="vertical-align: middle; padding-left:8px">
                    </span>
                </p>
                <button type="button" style="border:none;background-color: #ffffff;width: 68px;height: 50px;" class="close"
                    aria-label="Close" (click)="onCloseModal1()">
                    <span aria-hidden="true" style="color: #000000;font-size: 35px;">&times;</span>
                </button>
            </div>
            <div class="modal-body" style="text-align: center;padding-top:0px">
                <img src="../../../assets/images/confirmm.png">


                <p style="margin-bottom: 0px;font-weight: 500;">sent successfully!</p>
                <p style="margin-bottom: 0px;"><b>check out sheet </b>has been sent successfully</p>
                <button (click)="onCloseModal1()" class="rounded-2 text-white rounded-2 border-0 py-2 px-4 " style="background-color: #1f4068 !important ;    margin-top: 15px;
  margin-bottom: 15px;">
                    ← Back
                </button>
            </div>

        </div>
    </div>
</div>

<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display2}" style=" background-color: rgb(23 22 22 / 50%);;">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="    margin-top: 150px;">
            <div class="modal-header" style="background-color:#ffffff; border-bottom: none !important;position: relative;">
                <p class="modal-title"
                    style="color: #1C1B1F; font-size: 20px;   font-weight: 600; line-height: 24px; word-wrap: break-word">
                    <span class="form-label gray fw-bold" style="vertical-align: middle; padding-left:8px">
                        Bank Details of Refunding Process
                    </span>
                </p>
                <button type="button" style="border:none;background-color: #ffffff;width: 68px;height: 50px;" class="close"
                    aria-label="Close" (click)="onCloseModal2()">
                    <span aria-hidden="true" style="color: #000000;font-size: 35px;">&times;</span>
                </button>


            </div>

            <div class="modal-body">


                <div id="Bankdetails">
                    <!-- <p class="fw-bold mb-0"> Bank account information</p> -->
                    <p style="color: #605D62 !important;">This is Bank Details of Tenant , Necessary for Refunding Process</p>
                </div>
                <!--start Other Details form-->

                <div name="bankdetails">
                    <div class="row " *ngFor="let item of BankDetails">

                        <div class="col-12  mb-4">
                            <label class="fw-bold" style="color: #605D62;">Account Name</label>
                            <br>

                            <input readonly disabled value="{{ item.account_Name }}" class="form-control w-100 bg-white" type="text">
                        </div>
                        <div class="col-12  mb-4">
                            <label class="fw-bold" style="color: #605D62;">Account Iban </label>
                            <input readonly disabled value="{{ item.account_Iban }}" class="form-control w-100 bg-white" type="text">
                        </div>
                        <div class="col-12  mb-4">
                            <label class="fw-bold" style="color: #605D62;">Account No</label>
                            <input readonly disabled value="{{ item.account_No }}" class="form-control w-100 bg-white" type="text">
                        </div>
                        <div class="col-12  mb-4">
                            <label class="fw-bold" style="color: #605D62;">Account Swift</label>
                            <input readonly disabled value="{{ item.account_Swift }}" class="form-control w-100 bg-white" type="text">
                        </div>
                    </div>

                </div>
            </div>


        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display3}" style=" background-color: rgb(23 22 22 / 50%);;">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="    margin-top: 150px;">
            <div class="modal-header" style="background-color:#ffffff; border-bottom: none !important;position: relative;">
                <p class="modal-title"
                    style="color: #1C1B1F; font-size: 20px;   font-weight: 600; line-height: 24px; word-wrap: break-word">
                    <span class="form-label gray fw-bold" style="vertical-align: middle; padding-left:8px">
                        Refunding Process Details
                    </span>
                </p>
                <button type="button" style="border:none;background-color: #ffffff;width: 68px;height: 50px;" class="close"
                    aria-label="Close" (click)="onCloseModal3()">
                    <span aria-hidden="true" style="color: #000000;font-size: 35px;">&times;</span>
                </button>


            </div>

            <div class="modal-body">


                <div id="Bankdetails">
                    <!-- <p class="fw-bold mb-0"> Bank account information</p> -->
                    <p style="color: #605D62 !important;">Information of Refunding Process</p>
                </div>
                <!--start Other Details form-->

                <div name="bankdetails">
                    <div class="row ">

                        <div class="col-6  mb-4">
                            <label class="fw-bold" style="color: #605D62;">Invoice Amount</label>
                            <br>

                            <input readonly disabled value="{{ RefundDetails?.refund_Amount }}" class="form-control w-100 bg-white"
                                type="number">
                        </div>
                        <div class="col-6  mb-4">
                            <label class="fw-bold" style="color: #605D62;">Invoice Refund Status</label>
                            <input readonly disabled value="{{ RefundDetails?.refund_Paid }}" class="form-control w-100 bg-white"
                                type="text">
                        </div>
                        <div class="col-12  mb-4">
                            <label class="fw-bold" style="color: #605D62;">Refund Transaction ID </label>
                            <input [readOnly]="RefundDetails?.refund_Paid=='Paid'"
                                value="{{ RefundDetails?.refund_Transaction_ID }}" class="form-control w-100 bg-white"
                                type="text" (keypress)="ChangeRefund_ID($event)">
                        </div>

                        <div class="mb-3 col-12 col-md-12">
                            <label for="exampleInputPricepermonth" class="form-label gray fw-bold">Attachments</label>
                            <div class="row mt-2" *ngIf="RefundDetails?.refund_Attachment!=null">

                                <div class="accordion-body">
                                    <img *ngIf="Is_PDF==false" (click)="openmodel(RefundDetails?.refund_Attachment)"
                                        style="width: 100px;cursor: pointer;" [src]="RefundDetails?.refund_Attachment" class="me-2">

                                </div>
                                <div class="col-11 rounded-3   py-2 ms-3" style="border: 1px solid #8fa0b4">
                                    <div class="row">
                                        <div class="col-2 d-flex justify-content-center">
                                            <img width="48px" *ngIf="Is_PDF==true" src="assets/images/pdf-svgrepo-com.svg" />
                                            <img width="48px" *ngIf="Is_PDF==false" src="assets/images/jpg-svgrepo-com.svg" />

                                        </div>
                                        <div class="col-8">
                                            <h6>Refund Transaction Receipt</h6>

                                        </div>
                                        <div class="col-2 d-flex align-items-center justify-content-center">
                                            <div class="">
                                                <!-- <a class="me-3 cursor" routerLink="/apartments/contract/create-owner-contract"><img src="assets/images/apartmentImages/edit1.svg" /></a> -->
                                                <a class="me-3 cursor" *ngIf="RefundDetails?.refund_Attachment" target="_blank"
                                                    [href]="RefundDetails?.refund_Attachment"><img width="32px"
                                                        src="assets/images/download-minimalistic-svgrepo-com.svg" /></a>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="image-upload mainimage" *ngIf="RefundDetails?.refund_Attachment==null">
                                <input type="file" multiple="multiple" (change)="onUploadContract($event,'contract_Path')">
                                <div class="image-uploads">
                                    <div class="d-flex align-items-center justify-content-center text-center h-100">
                                        <div *ngIf="!selectedContractImg" class="text-center imageData pt-2">
                                            <div class="icon m-auto">
                                                <img src="/assets/images/upload 1.svg" alt="img">
                                            </div>
                                            <p class="mb-0">Click to upload <span class="text-muted fw-normal"> or drag and drop</span></p>
                                            <p class="text-muted fw-normal">PNG, JPG, GIF, or MP4 (max. 8MB)</p>
                                        </div>
                                        <ng-container *ngIf="selectedContractImg">
                                            <a (click)="opencloseModal(selectedContractImg.url)">
                                                <img *ngIf="selectedContractImg.url" [src]="selectedContractImg.url" alt="img"
                                                    style="height: 124px;width:150px;">
                                            </a>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
            <div class="modal-footer" *ngIf="RefundDetails?.refund_Paid!='Paid'">

                <button class="rounded-2 text-white rounded-2 border-0 py-2 px-4"
                    style="background-color: #1f4068 !important"
                    (click)="PostRefunding()">
                    Confirm Refund
                </button>
                <!-- Confirm -->

            </div>


        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display33}" style="background-color: rgba(90,90,90,0.5);">
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document" style="width:900px;">
        <div class="modal-content position-relative">
            <div class="modal-header p-0 m-0 d-flex justify-content-start" style="position: relative;">
                <button type="button" class="close" aria-label="Close" (click)="oncloseModal()">
                    <img src="../../../../assets/images/ic_round-close.svg" alt="">
                </button>
            </div>
            <div class="modal-body p-0 m-0">
                <img [src]="imageSize" style="width:100%;height: 500px" />

            </div>

            <!-- <div class="modal-footer">
              <button type="button" class="btn btn-white bbtclose" (click)="oncloseModal()">
close
</button>

          </div> -->


        </div>
    </div>
</div>
